import { Injectable } from '@angular/core';

import { CheckoutPageMetaResolver } from '@spartacus/checkout/base/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class DpCheckoutPageMetaResolver extends CheckoutPageMetaResolver {
  resolveHeading(): Observable<string> {
    return this.basePageMetaResolver.resolveTitle().pipe(map((title) => title ?? ''));
  }
}
